
import { create_product_mobile_slider, validateCommentSubmission } from './helper/functions';

(function ($) {
	const ele = $('.related ul.products');
	const parent = $(ele).parent('.related');

	if (parent.length) {
		create_product_mobile_slider({
			selector: 'li',
			element: ele,
			addMargins: true,
			parent: parent
		});
	}

	$('.variations_form')
		.on('found_variation', function (event, variation) {
			const stock = $('.hpy--badge_stock');
			stock.attr('style', 'display: none !important');

			$('.hpy--badge_stock_t').remove();
			$('.woocommerce-variation-add-to-cart .woocommerce-product-variation-price').html(variation.price_html);
			$(variation.is_in_stock ? hpySingleProduct.stock_badges.instock : hpySingleProduct.stock_badges.outofstock).addClass('hpy--badge_stock_t').insertAfter(stock);
		})
		.on('reset_data', function () {
			$('.hpy--badge_stock_t').remove();
			$('.hpy--badge_stock').show();
		});

	const main = new Splide('#product---image', {
		type: 'fade',
		pagination: false,
		type: 'loop',
		heightRatio: 1
	});

	const nav = document.getElementById('product--image_nav');
	if (nav) {
		const thumbnails = new Splide('#product--image_nav', {
			isNavigation: true,
			gap: "1rem",
			pagination: false,
			autoWidth: true,
			updateOnMove: true,
			arrows: false,
		});

		main.sync(thumbnails);
		main.mount();
		thumbnails.mount();
		main.event.emit('overflow', main.Components.Layout.isOverflow())
		thumbnails.event.emit('overflow', thumbnails.Components.Layout.isOverflow())
	} else {
		main.mount();
	}

	validateCommentSubmission();


}(jQuery))